// extracted by mini-css-extract-plugin
export var info = "LogInTest-module--info--nmJP1";
export var logInDiv = "LogInTest-module--logInDiv--W7TEY";
export var logOutBtn = "LogInTest-module--logOutBtn--iq74F";
export var logOutBtnWrapper = "LogInTest-module--logOutBtnWrapper--90kuC";
export var token = "LogInTest-module--token--U0CLO";
export var userDiv = "LogInTest-module--userDiv--grCa0";